import { render, staticRenderFns } from "./AssignmentDetailsTab.vue?vue&type=template&id=bb9e1890&scoped=true&"
import script from "./AssignmentDetailsTab.vue?vue&type=script&lang=js&"
export * from "./AssignmentDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9e1890",
  null
  
)

export default component.exports